<template>
  <v-text-field
    class="input-styles inputPrice text-center"
    type="number"
    :value="modelValue"
    placeholder="0.00"
    prefix="$"
    hide-details
    outlined
    @input="(val) => setInput(val)"
    :disabled="disabled"
  ></v-text-field>
</template>

<script>
export default {
  name: "CurrencyInput",
  props: {
    disabled: Boolean,
    modelValue: String,
    setInput: Function,
  },
};
</script>
<style scoped>
.inputPrice >>> input[type="number"] {
  -moz-appearance: textfield;
  max-width: 50%;
}

.inputPrice >>> input::-webkit-outer-spin-button,
.inputPrice >>> input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.inputPrice >>> .v-text-field__slot {
  display: flex;
  justify-content: center;
}
</style>
